/**
 * Detects whether plain text looks like a broken bullet list — i.e. a bullet
 * marker line (•, –, -) is followed by a non-bullet continuation line, which
 * is a common artefact of copying text from PDFs.
 */
export function detectsBrokenBulletList(text: string): boolean {
  const lines = text.split(/\r?\n/);
  let prevWasBullet = false;
  for (const line of lines) {
    const trimmed = line.trim();
    if (!trimmed) {
      prevWasBullet = false;
      continue;
    }
    const isBullet = /^[•\-–]\s/.test(trimmed);
    if (prevWasBullet && !isBullet) return true;
    prevWasBullet = isBullet;
  }
  return false;
}

/**
 * Rebuilds a broken bullet list from plain text (clipboard content).
 * Splits by newlines, merges continuation lines onto their preceding bullet
 * item, and returns proper <ul><li> HTML.
 */
export function fixBrokenBulletListFromText(text: string): string {
  const lines = text.split(/\r?\n/);
  const listItems: string[] = [];
  const preBulletParas: string[] = [];
  let currentItem: string | null = null;

  for (const line of lines) {
    const trimmed = line.trim();
    if (!trimmed) continue;

    const bulletMatch = trimmed.match(/^[•\-–]\s+(.*)/);
    if (bulletMatch) {
      if (currentItem !== null) listItems.push(currentItem);
      currentItem = bulletMatch[1].trim();
    } else if (currentItem !== null) {
      // continuation line — join with a space
      currentItem = currentItem + ' ' + trimmed;
    } else {
      preBulletParas.push(trimmed);
    }
  }
  if (currentItem !== null) listItems.push(currentItem);

  let result = preBulletParas.map((p) => `<p>${p}</p>`).join('');
  if (listItems.length > 0) {
    result += `<ul>${listItems.map((i) => `<li><p>${i}</p></li>`).join('')}</ul>`;
  }
  return result;
}
